// extracted by mini-css-extract-plugin
module.exports = {"root":"content-box_root__mS_Ri","secondary":"content-box_secondary__Y2ll7","footer":"content-box_footer__6CcdX"};